import React from 'react';
import type { SVGProps } from 'react';
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 19"
    {...props}
  >
    <path
      fill={props?.fill || 'rgb(172, 185, 201)'}
      d="M18.343 5.589c0-1.481-.57-2.735-1.67-3.722C16.026 1.26 15.304.842 14.47.652 14.128.576 13.786.5 13.407.5H5.319c-.114 0-.228.038-.342.038a5.2 5.2 0 0 0-1.709.494c-1.1.57-1.936 1.405-2.43 2.506a5.9 5.9 0 0 0-.455 1.595c0 .114-.038.228-.038.342v8.012c0 .114.038.228.038.342.076.684.265 1.33.607 1.899.57 1.025 1.367 1.785 2.43 2.278.532.266 1.102.38 1.71.456.151 0 .34.038.493.038h7.48c2.278 0 4.329-1.519 4.974-3.684q.228-.74.228-1.48c.038-2.659.038-5.203.038-7.747m-1.405 7.595c0 1.177-.455 2.126-1.29 2.924-.57.531-1.254.797-2.051.911-.19.038-.342.038-.532.038H5.547a3.82 3.82 0 0 1-3.721-3c-.076-.266-.076-.57-.076-.835V5.665c0-.684.152-1.33.493-1.937.57-.988 1.405-1.595 2.544-1.86.266-.077.57-.077.836-.077h7.556c1.177 0 2.164.494 2.924 1.405.493.57.76 1.253.835 1.975 0 .152.038.304.038.456-.038 2.544-.038 5.05-.038 7.557"
    />
    <path
      fill={props?.fill || 'rgb(172, 185, 201)'}
      d="M15.575 4.26c0 .569-.456 1.025-1.025 1.025-.57 0-1.026-.456-1.026-1.026s.456-1.025 1.026-1.025c.57-.038 1.025.456 1.025 1.025M9.347 4.603a4.83 4.83 0 0 0-4.823 4.822 4.83 4.83 0 0 0 4.823 4.823c2.658 0 4.86-2.164 4.86-4.823 0-2.658-2.203-4.822-4.86-4.822m0 8.278A3.47 3.47 0 0 1 5.89 9.425 3.47 3.47 0 0 1 9.347 5.97a3.47 3.47 0 0 1 3.455 3.455 3.444 3.444 0 0 1-3.455 3.456"
    />
  </svg>
);
export default SvgInstagram;
